import React, {  useState, useEffect} from 'react'
import { Route, Routes , useLocation} from 'react-router-dom';
import Header from '../components/Header/Main';
import Footer from '../components/Footer/Main';
import Home from '../components/Home/Main';
import About from '../components/About/Main';
// import Chefs from '../components/Chef/Main';
import Contact from '../components/Contact/Main';
import Book from '../components/Book/Main';
// import Carousel from '../components/Carousel/Main';
import Menu from '../components/Menu/Menu';

function Index() {

  const [homepage, sethomepage] = useState(false)
    const location = useLocation();
    useEffect(() => {
      if (location.pathname === "/carousel"){
        sethomepage(false)
      }else{
        sethomepage(true)
      }
    }, [location])

  const path = location.pathname
  useEffect(() => {
    window.scroll(0, 0)
}, [path]);

  return (
    <>
      {homepage && <Header/>}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/ourchefs" element={<Chefs />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/reservation" element={<Book />} />
        {/* <Route path="/carousel" element={<Carousel />} /> */}
      </Routes>
      
      {homepage && <Footer /> }
    </>
  )
}

export default Index